export const iconsData = [
  {
    name: "mainIcon",
    icon: (
      <svg viewBox="-1114 -1428 866 342">
        <path
          fill="#333"
          d="M-961-1428h572a4 4 0 0 1 4 4v92a4 4 0 0 1-4 4h-572a4 4 0 0 1-4-4v-92a4 4 0 0 1 4-4M-961-1187h572a4 4 0 0 1 4 4v92a4 4 0 0 1-4 4h-572a4 4 0 0 1-4-4v-92a4 4 0 0 1 4-4M-1110-1307h557a4 4 0 0 1 4 4v92a4 4 0 0 1-4 4h-557a4 4 0 0 1-4-4v-92a4 4 0 0 1 4-4"
        />
        <path
          fill="#9566f1"
          d="M-527-1307h274a4 4 0 0 1 4 4v92a4 4 0 0 1-4 4h-274a4 4 0 0 1-4-4v-92a4 4 0 0 1 4-4"
        />
      </svg>
    ),
  },

  {
    name: "arrowRight",
    icon: (
      <svg viewBox="19 18 161 162">
        <path d="m104 19-9 8 61 65-137 1v13l138-1-61 66 9 8 75-81z" />
      </svg>
    ),
  },

  {
    name: "chevronLeft",
    icon: (
      <svg viewBox="0 0 50 50">
        <path d="M28 32.4c.1 0 .3-.1.4-.2.2-.2.2-.5 0-.7L22.2 25l6.7-6.5c.2-.2.2-.5 0-.7s-.5-.2-.7 0L21 24.7c-.1.1-.2.2-.2.4 0 .1.1.3.2.4l7.1 6.8c.1 0 .3.1.4.1" />
      </svg>
    ),
  },

  {
    name: "chevronDown",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="M233 407c13 12 33 12 46 0l192-192a32 32 0 0 0-46-46L256 339 87 169a32 32 0 0 0-46 46l192 192z" />
      </svg>
    ),
  },

  {
    name: "facebook",
    icon: (
      <svg viewBox="0 0 320 512">
        <path d="M80 299v213h116V299h87l18-97H196v-35c0-52 20-72 73-72l37 2V8c-15-4-50-8-70-8C129 0 80 51 80 159v43H14v97z" />
      </svg>
    ),
  },

  {
    name: "linkedin",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3M447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
      </svg>
    ),
  },

  {
    name: "twitter",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="m459 152 1 13A297 297 0 0 1 0 417l25 1c49 0 94-17 131-45-47-1-85-31-98-73l19 2c10 0 19-1 28-4-48-9-84-52-84-103v-1c14 8 30 13 47 13A105 105 0 0 1 36 67c51 64 129 105 216 110l-3-24a105 105 0 0 1 182-72c24-4 47-13 67-25-8 24-25 45-46 58 21-3 41-9 60-17-14 21-32 40-53 54" />
      </svg>
    ),
  },

  {
    name: "instagram",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141m0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7m146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8m76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8M398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1" />
      </svg>
    ),
  },
];
